import {createApiCall} from '../utils';
import {SERVICE_NAMES} from '../constants';
import type {ApiCallOptions} from '../types';
import type {
    ApiResponseWrapperFieldEvaluationView,
    ApiResponseWrapperConditionsResponse,
    TransactionConditionsResponse,
    ApiResponseWrapperDeleteResponse,
    FieldEvaluationRequest,
    CreateConditionsRequest
} from './api.d';

export const evaluateFieldCondition = (
    transactionId: string,
    documentId: string,
    approvalId: string,
    fieldId: string,
    data: FieldEvaluationRequest,
    options: ApiCallOptions = {}
) => createApiCall<ApiResponseWrapperFieldEvaluationView>(
    SERVICE_NAMES.CONDITIONAL_FIELD,
    'PUT',
    `transactions/${transactionId}/documents/${documentId}/approvals/${approvalId}/fields/${fieldId}/evaluation`
)({data, ...options});

export const updateFieldConditions = (
    transactionId: string,
    documentId: string,
    approvalId: string,
    fieldId: string,
    data: CreateConditionsRequest,
    options: ApiCallOptions = {}
) => createApiCall<ApiResponseWrapperConditionsResponse>(
    SERVICE_NAMES.CONDITIONAL_FIELD,
    'PUT',
    `transactions/${transactionId}/documents/${documentId}/approvals/${approvalId}/fields/${fieldId}/conditions`
)({data, ...options});

export const getFieldConditions = (
    transactionId: string,
    documentId: string,
    approvalId: string,
    fieldId: string,
    options: ApiCallOptions = {}
) => createApiCall<ApiResponseWrapperConditionsResponse>(
    SERVICE_NAMES.CONDITIONAL_FIELD,
    'GET',
    `transactions/${transactionId}/documents/${documentId}/approvals/${approvalId}/fields/${fieldId}/conditions`
)({...options});

export const deleteFieldConditions = (
    transactionId: string,
    documentId: string,
    approvalId: string,
    fieldId: string,
    options: ApiCallOptions = {}
) => createApiCall<void>(
    SERVICE_NAMES.CONDITIONAL_FIELD,
    'DELETE',
    `transactions/${transactionId}/documents/${documentId}/approvals/${approvalId}/fields/${fieldId}/conditions`
)({...options});

export const getTransactionConditions = (
    transactionId: string,
    options: ApiCallOptions = {}
) => createApiCall<TransactionConditionsResponse>(
    SERVICE_NAMES.CONDITIONAL_FIELD,
    'GET',
    `transactions/${transactionId}/conditions`
)({...options});

export const deleteTransactionConditions = (
    transactionId: string,
    options: ApiCallOptions = {}
) => createApiCall<ApiResponseWrapperDeleteResponse>(
    SERVICE_NAMES.CONDITIONAL_FIELD,
    'DELETE',
    `transactions/${transactionId}/conditions`
)({...options});

export const conditionalFieldApi = {
    evaluateFieldCondition,
    updateFieldConditions,
    getFieldConditions,
    deleteFieldConditions,
    getTransactionConditions,
    deleteTransactionConditions
};
